import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { PaginatedTestimonialsResponse } from './types';

export interface UseGetTestimonialsParams {
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export const useGetTestimonials = ({
	page = 1,
	limit = 200,
	enabled = true,
}: UseGetTestimonialsParams = {}) => {
	const query = useQuery<PaginatedTestimonialsResponse>({
		queryKey: ['testimonials', 'management', page, limit],
		enabled,
		placeholderData: previousData => previousData,
		queryFn: async () => {
			const { data } = await api.get<PaginatedTestimonialsResponse>('/management/testimonial/findAll', {
				params: { page, limit },
			});
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? {
					totalDocs: query.data.totalDocs,
					totalPages: query.data.totalPages,
					page: query.data.page,
					hasPrevPage: query.data.hasPrevPage,
					hasNextPage: query.data.hasNextPage,
					prevPage: query.data.prevPage,
					nextPage: query.data.nextPage,
				}
			: null,
	};
};
